export const SIZES = {
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;
